class Auth {
  loginWithSocialMedia(provider, callbackAction) {
    window.localStorage.removeItem(ACTION_KEY);
    window.sessionStorage.removeItem('openWindowForSocialLogin');
    const $url = `/user/login/social/${provider}`;
    const ACTION_KEY = 'social-login';
    window.open($url, ACTION_KEY);
    window.sessionStorage.setItem('openWindowForSocialLogin', true);

    const socialLoginCallBack = event => {
      if (event.storageArea != localStorage) return;

      if (event.key === ACTION_KEY) {
        const data = JSON.parse(event.newValue);
        callbackAction(data);

        window.removeEventListener('storage', socialLoginCallBack, false);
        window.localStorage.removeItem(ACTION_KEY);
        window.sessionStorage.removeItem('openWindowForSocialLogin');
      }
    };

    window.addEventListener('storage', socialLoginCallBack, false);
  }
}

const auth = new Auth();

export default auth;
